import { useDispatch } from "react-redux";
import styled from "styled-components";
import { BASIC_BROWN, BASIC_WHITE, BASIC_YELLOW } from "../../constants/colors";
import { PageRoutes } from "../../constants/routes";
import { appActions } from "../../ducks/app";
import { Link } from "../atoms/Link";

export const Footer: React.FC = () => {
  const dispatch = useDispatch();

  return (
    <FooterContainer>
      <FooterNavContainer>
        <Link
          color={BASIC_WHITE}
          fontSize="13px"
          href={PageRoutes.COMMERCIAL_LAW}
          text={"特定商取引法に基づく表記"}
        />
        |
        <Link
          color={BASIC_WHITE}
          fontSize="13px"
          href={PageRoutes.LEGAL_FOR_USE + "#privacy_policy"}
          text={"個人情報保護方針"}
        />
        |
        <Link
          color={BASIC_WHITE}
          fontSize="13px"
          href={PageRoutes.LEGAL_FOR_USE + "#term_of_service"}
          text={"利用規約"}
        />
        |
        <Link
          color={BASIC_WHITE}
          fontSize="13px"
          href={PageRoutes.FAQ}
          text={"よくある質問"}
        />
        |
        <Link
          color={BASIC_WHITE}
          fontSize="13px"
          text={"お問い合わせ"}
          onClick={() => dispatch(appActions.showContactUsModal())}
        />
      </FooterNavContainer>
      <CopyrightContainer>
        <Copyright>Copyright © Joyfull Co.,Ltd.All rights reserved.</Copyright>
      </CopyrightContainer>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  position: relative;
  color: ${BASIC_WHITE};
  background-color: ${BASIC_BROWN};
  padding-bottom: 15px;
  margin: 0;
  min-width: 375px;
  border-top: 3px solid ${BASIC_YELLOW};
`;

const FooterNavContainer = styled.div`
  color: rgba(255, 255, 255, 0.5);
  line-height: 2.1em;
  margin-bottom: 1.2em;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 30px 0 30px;
  flex-wrap: wrap;
  gap: 5px;
`;

const CopyrightContainer = styled.div`
  text-align: center;
`;

const Copyright = styled.p`
  font-size: 12px;
  font-weight: 500;
  line-height: 1em;
  color: ${BASIC_WHITE};
  margin-bottom: 1.2em;
`;
